import { useState, useEffect } from 'react';
import { remoteConfig } from '../lib/firebase';
import { fetchAndActivate } from 'firebase/remote-config';
import log from '../utils/logger';

interface UseRemoteConfigReturn {
  loaded: boolean;
  error: string | null;
}

export function useRemoteConfig(): UseRemoteConfigReturn {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let retryCount = 0;
    const maxRetries = 3;
    const retryDelay = 2000; // 2 seconds

    const initializeRemoteConfig = async () => {
      try {
        // Configure Remote Config settings
        remoteConfig.settings = {
          minimumFetchIntervalMillis: 3600000, // 1 hour
          fetchTimeoutMillis: 60000, // 60 seconds
        };

        // Fetch and activate Remote Config
        await fetchAndActivate(remoteConfig);
        
        log.debug('✅ Remote Config loaded successfully');
        setLoaded(true);
        setError(null);
      } catch (error) {
        log.error('❌ Error loading Remote Config:', error);
        
        if (retryCount < maxRetries) {
          retryCount++;
          log.debug(`🔄 Retrying Remote Config (attempt ${retryCount}/${maxRetries})...`);
          setTimeout(initializeRemoteConfig, retryDelay);
        } else {
          setError('Failed to load configuration. Please refresh the page.');
        }
      }
    };

    initializeRemoteConfig();
  }, []);

  return { loaded, error };
}